import React from "react";

export const cmToFtIn = (cm) => {
  if (!cm) return { ft: "", inch: "" };
  const totalIn = Math.round(Number(cm) / 2.54);
  return { ft: Math.floor(totalIn / 12), inch: totalIn % 12 };
};
export const ftInToCm = (ft, inch) => {
  const f = Number(ft) || 0, i = Number(inch) || 0;
  if (!f && !i) return null;
  return Math.round((f * 12 + i) * 2.54);
};
export const formatHeight = (cm) => {
  if (!cm) return null;
  const { ft, inch } = cmToFtIn(cm);
  return `${ft}'${inch}" · ${cm} cm`;
};

const fld = "w-full rounded-xl bg-[#0C0A0A]/60 border border-[#D4AF37]/20 focus:border-[#D4AF37]/60 outline-none px-3 py-2.5 text-sm text-[#FBF8F3] placeholder:text-[#9E978E]";

export function HeightInput({ valueCm, onChange, testid = "height" }) {
  const { ft, inch } = cmToFtIn(valueCm);
  const setFtIn = (nf, ni) => onChange(ftInToCm(nf, ni));
  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <label className="text-[10px] uppercase tracking-wide text-[#9E978E]">Feet</label>
          <input data-testid={`${testid}-ft`} type="number" min="3" max="8" value={ft}
            onChange={(e) => setFtIn(e.target.value, inch)} className={fld} placeholder="5" />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wide text-[#9E978E]">Inches</label>
          <input data-testid={`${testid}-in`} type="number" min="0" max="11" value={inch}
            onChange={(e) => setFtIn(ft, e.target.value)} className={fld} placeholder="10" />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wide text-[#9E978E]">Centimeters</label>
          <input data-testid={`${testid}-cm`} type="number" min="120" max="250" value={valueCm || ""}
            onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)} className={fld} placeholder="178" />
        </div>
      </div>
      {valueCm ? <p className="text-[11px] text-[#C9A96E] mt-1.5">{formatHeight(valueCm)}</p>
        : <p className="text-[11px] text-[#9E978E] mt-1.5">Enter feet/inches or centimeters — we convert automatically.</p>}
    </div>
  );
}
